import { Component, Input, Output, EventEmitter } from '@angular/core';



@Component({
  selector: 'live-photo',
  templateUrl: 'livePhoto.component.html',
  styleUrls: ['./livePhoto.component.scss']
})
export class LivePhotoComponent {
  @Input() photoSrc: String | '';
  @Input() videoSrc: String | '';
  @Input() width: String | '320px';
  @Input() height: String | '320px';
  styleString: null;

  styleAsString(width, height) {
    return `width: ${width} ; height: ${height}`
  }

  _photoSrc () {
    return `${this.photoSrc}`
  }
  _videoSrc () {
    return `${this.videoSrc}`
  }

}



// WEBPACK FOOTER //
// ./src/app/components/livePhoto/livePhoto.component.ts